import { createFileRoute, Link, notFound } from "@tanstack/react-router";
import { BN_SERVICES, findBnLocation, type BnLocation } from "@/content/bn/locations";
import { BnCityServiceView } from "@/components/bn-city/BnCityService";
import { bnCityServiceHead } from "@/lib/bn-city-head";

export const Route = createFileRoute("/bn/seo-services/$location/$service")({
  loader: ({ params }): { loc: BnLocation; svcSlug: string } => {
    const loc = findBnLocation(params.location);
    if (!loc) throw notFound();
    if (!BN_SERVICES[params.service]) throw notFound();
    return { loc, svcSlug: params.service };
  },
  head: ({ loaderData }) =>
    bnCityServiceHead(
      loaderData?.loc,
      loaderData ? BN_SERVICES[loaderData.svcSlug] : undefined,
      loaderData?.svcSlug,
    ),
  component: BnCityServicePage,
  notFoundComponent: () => (
    <div className="container-x py-32 text-center">
      <h1 className="font-display text-3xl">পেজটি খুঁজে পাওয়া যায়নি</h1>
      <Link to="/bn/services" className="mt-6 inline-flex text-primary">সেবাসমূহে ফিরে যান</Link>
    </div>
  ),
});

function BnCityServicePage() {
  const { loc, svcSlug } = Route.useLoaderData();
  return <BnCityServiceView loc={loc} svcSlug={svcSlug} />;
}
